import Navigation from '../components/Navigation';
import CTA from '../components/CTA';
import FooterCentered from '../components/FooterCentered';
import { motion } from 'framer-motion';

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, delay: i * 0.12, ease: [0.25, 0.46, 0.45, 0.94] },
    }),
};

const stats = [
    { label: 'Client Satisfaction', value: '100%' },
    { label: 'Projects Delivered', value: '40+' },
    { label: 'Avg. Client Growth', value: '50%+' },
];

export default function About() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-void min-h-screen"
        >
            <Navigation />
            <main>
                <section className="relative pt-36 sm:pt-44 pb-24 px-6 lg:px-8">
                    <div className="mx-auto max-w-3xl">
                        <motion.div
                            custom={0}
                            initial="hidden"
                            animate="visible"
                            variants={fadeUp}
                        >
                            <p className="text-xs font-outfit font-semibold tracking-[0.2em] uppercase text-accent mb-4">
                                About Us
                            </p>
                            <h1 className="font-syne text-4xl sm:text-5xl font-bold text-text-primary leading-tight">
                                A lean team building real things for real businesses
                            </h1>
                        </motion.div>
                        <motion.p
                            custom={1}
                            initial="hidden"
                            animate="visible"
                            variants={fadeUp}
                            className="mt-8 font-outfit text-base sm:text-lg text-text-secondary leading-relaxed max-w-2xl"
                        >
                            Big Web Labs was founded to cut through the noise. We saw too many businesses
                            overpaying for underwhelming work, stuck in long contracts with agencies that
                            couldn't move fast enough. We built something different — a specialized team
                            that uses the latest AI tools and modern development practices to ship faster
                            and cost less.
                        </motion.p>
                        <motion.p
                            custom={2}
                            initial="hidden"
                            animate="visible"
                            variants={fadeUp}
                            className="mt-6 font-outfit text-base text-text-secondary leading-relaxed max-w-2xl"
                        >
                            Our sweet spot is solopreneurs and small teams who need a reliable partner —
                            not a headcount problem. Whether it's a website, an AI automation, or a
                            workflow that saves you 10 hours a week, we build what matters and get
                            out of your way.
                        </motion.p>
                    </div>
                </section>

                <section className="py-16 px-6 lg:px-8 border-y border-border-subtle">
                    <div className="mx-auto max-w-3xl grid grid-cols-3 gap-8">
                        {stats.map((stat, i) => (
                            <motion.div
                                key={stat.label}
                                custom={i}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeUp}
                                className="text-center"
                            >
                                <p className="font-syne text-3xl sm:text-4xl font-bold text-accent">
                                    {stat.value}
                                </p>
                                <p className="mt-2 font-outfit text-sm text-text-muted">
                                    {stat.label}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </section>

                <CTA />
            </main>
            <FooterCentered />
        </motion.div>
    );
}
